import React from 'react';
const Delete = ({ ...r }) => {
  return(
    <svg
			xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
			{...r}
		>
			<path
				fill="#272727"
                d="M17 6h4a1 1 0 110 2h-1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V8H3a1 1 0 010-2h4V3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2H6v12h12V8zm-9 4a1 1 0 112 0v4a1 1 0 11-2 0v-4zm4 0a1 1 0 112 0v4a1 1 0 11-2 0v-4zM9 4v2h6V4H9z"
            ></path>            
		</svg>
  );}

export default Delete;